import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '@/config/supabase'
import { analytics, trackEvent } from '@/services/analytics'

export default function AuthCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code')
        if (code) {
          const { error } = await supabase.auth.exchangeCodeForSession(code)
          if (error) throw error
        }

        // OAuth sonrasinda kullaniciyi cek ve analytics icin kaydet
        const { data: { user } } = await supabase.auth.getUser()
        if (user) {
          analytics.setDistinctId(user.id)
          const provider = user.app_metadata?.provider || 'oauth'
          trackEvent({
            event: 'scraible_login_success',
            distinct_id: user.id,
            properties: {
              method: provider,
              page: 'auth_callback',
              email: user.email,
            },
          })
        }

        navigate('/')
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Kimlik doğrulama sırasında hata oluştu')
      }
    }
    handleCallback()
  }, [navigate, searchParams])

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md card p-6 md:p-8 text-center">
        {error ? (
          <div className="text-red-300">{error}</div>
        ) : (
          <div className="text-white/70">Hesabınıza giriş yapılıyor...</div>
        )}
      </div>
    </div>
  )
}


